import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class MenuAsideService {
  // Public properties
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  constructor() { }

  loadMenu(config) {
    // get menu list
    
    this.menuList$.next(config.aside);
  }
}
